import "./promotionModal.css";
import { routes } from "../../routes";
import { useNavigate } from "react-router-dom";
import { home } from "../../utils/globalImages";
import { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { togglePayment } from "../../redux/slices/accountSlice";
import { toggleOnboard } from "../../redux/slices/onBoardingSlice";
import { setCookie, getCookie } from "../../services/cookies.service";

const ANIMATION_DURATION = 300;
const CLOSED_BANNER_KEY = "closed_local_promotion_banner";

function PromotionModal() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(true);
  const [closing, setClosing] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [authReady, setAuthReady] = useState(false);
  const user = useSelector((state) => state?.auth?.user);
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    if (!isLoggedIn || user) {
      setAuthReady(true);
    }
    setIsClosed(getCookie(CLOSED_BANNER_KEY) === "true");
    setVisible(true);
    setClosing(false);
  }, [isLoggedIn, user]);

  const bannerImage = useMemo(() => {
    if (!authReady) return null;
    if (user?.free_boxes) return home.freeBoxes;
    if (!isLoggedIn) return home.freeBoxAndBonus;
    if (user?.initial_deposit) return home.welcomeBonus;
  }, [authReady, isLoggedIn, user]);

  const handleClose = () => {
    setCookie(CLOSED_BANNER_KEY, "true", 30);
    setIsClosed(true);
    setClosing(true);

    setTimeout(() => setVisible(false), ANIMATION_DURATION);
  };

  const handleNavigate = () => {
    handleClose();
    setTimeout(() => {
      if (user?.initial_deposit)
        return dispatch(togglePayment({ payment: true }));
      if (user?.free_boxes)
        return navigate(`${routes.ACCOUNT}/${routes.ACCOUNT_FREEBOXES}`);
      if (!isLoggedIn) return dispatch(toggleOnboard({ register: true }));
    }, 500);
  };

  if (!authReady || !bannerImage || isClosed || !visible) return null;

  return (
    <div
      className={`promoModalOverlay ${closing ? "fade-out" : ""}`}
      onClick={handleClose}
    >
      <div
        className={`promoModalBox ${closing ? "scale-out" : "scale-in"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="promoCloseBtn"
          onClick={handleClose}
          aria-label="Close promotion"
        >
          ×
        </button>
        <img
          src={bannerImage}
          alt="Promotion"
          className="promoImage"
          onClick={handleNavigate}
        />
      </div>
    </div>
  );
}

export default PromotionModal;
